interface PointHistoryAdminFormLike {
    getOpenButton(root?: ParentNode): HTMLButtonElement | null;
    getOverlay(root?: ParentNode): HTMLElement | null;
    getForm(root?: ParentNode): HTMLFormElement | null;
    getAmountInput(): HTMLInputElement | null;
    getPanel(): HTMLElement;
    getCloseButtons(root?: ParentNode): HTMLElement[];
    getInvalidateButton(root: EventTarget | Element | null | undefined): HTMLButtonElement | null;
}

interface PointHistoryAdminHandlerLike {
    openAdjustModal(): void;
    closeModal(): void;
    handleSubmit(event: SubmitEvent): Promise<void>;
    handleAmountKeydown(event: KeyboardEvent): void;
    handleAmountPaste(event: ClipboardEvent): void;
    handleAmountInput(): void;
    handleInvalidateButton(invalidateBtn: HTMLButtonElement): void;
}

export class PointHistoryAdminListener {
    public form: PointHistoryAdminFormLike;

    public handler: PointHistoryAdminHandlerLike;

    public constructor(form: PointHistoryAdminFormLike, handler: PointHistoryAdminHandlerLike) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const formEl = this.form.getForm();
        const amountEl = this.form.getAmountInput();
        const panel = this.form.getPanel();

        if (formEl instanceof HTMLFormElement) {
            formEl.addEventListener("submit", (event) => {
                void this.handler.handleSubmit(event);
            });
        }

        if (amountEl instanceof HTMLInputElement) {
            amountEl.addEventListener("keydown", (event) => this.handler.handleAmountKeydown(event));
            amountEl.addEventListener("paste", (event) => this.handler.handleAmountPaste(event));
            amountEl.addEventListener("input", () => this.handler.handleAmountInput());
        }

        if (panel instanceof HTMLElement) {
            panel.addEventListener(
                "click",
                (event) => {
                    const target = event.target;
                    if (!(target instanceof Element)) return;

                    const openBtn = this.form.getOpenButton(target.parentElement ?? panel);
                    if (openBtn instanceof HTMLButtonElement && openBtn.contains(target)) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        this.handler.openAdjustModal();
                        return;
                    }

                    const closeBtn = this.form
                        .getCloseButtons(target.parentElement ?? panel)
                        .find((button) => button.contains(target));
                    if (closeBtn instanceof HTMLElement) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        this.handler.closeModal();
                        return;
                    }

                    const overlay = this.form.getOverlay(target.parentElement ?? panel);
                    if (overlay instanceof HTMLElement && overlay === target) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        this.handler.closeModal();
                        return;
                    }

                    const invalidateBtn = this.form.getInvalidateButton(target);
                    if (!(invalidateBtn instanceof HTMLButtonElement)) return;

                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    this.handler.handleInvalidateButton(invalidateBtn);
                },
                true,
            );
        }
    }
}
